import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import "../assets/styles/buttons.scss";
import ActivationPage from "../components/activation/ActivationPage";
import NotFound from "../components/general/NotFound";
import "./App.scss";

function App() {
  return (
    <div className="blikst-app-container">
      <Router>
        <Routes>
          <Route
            path="/"
            element={<ActivationPage />}
          />
          <Route
            path="/:token"
            element={<ActivationPage />}
          />
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </Router>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        transition={Slide}
        style={{ marginTop: "50px" }}
      />
    </div>
  );
}

export default App;
